export default __webpack_public_path__ + "img/18b212ebd2af46109e5170bc0f4c5a07.png";